<template>
    <Fragment>
        <spinner :show="loading" />
        <transition name="fade" :duration="{ leave: 0, enter: 800 }">
            <carousel
                key="carousel"
                v-show="!loading"
                ref="carousel"
                v-images-loaded="imageLoaded"
                class="slideshow"
                :perPage="1"
                :mouseDrag="false"
                paginationColor="#F2C0DE"
                paginationActiveColor="#F2C0DE"
                :paginationPadding="0"
                :paginationSize="5"
                :centerMode="true"
                :navigateTo="navigateTo"
                @page-change="handlePageChange"
            >
                <slide
                    style="visibility: visible;"
                    v-for="(image, index) in images"
                    :key="image.key"
                    @slide-click="handleImgClick(image, index)"
                >
                    <img
                        :src="image.uri"
                        :alt="image.alt"
                        class="slide-image"
                    />
                </slide>
            </carousel>
        </transition>
    </Fragment>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
import { Fragment } from "vue-fragment";
import Spinner from "./spinner.vue";
import imagesLoaded from "vue-images-loaded";

export default {
    props: {
        images: Array,
        navigateTo: Number,
    },
    directives: {
        imagesLoaded,
    },
    components: {
        Carousel,
        Slide,
        Fragment,
        Spinner,
    },
    data() {
        return {
            finishRendering: false,
            loading: true,
            initTime: null,
        };
    },
    methods: {
        handlePageChange(pageIndex) {
            if (this.finishRendering && !this.loading)
                this.$emit("image-changed", this.images[pageIndex]?.key);
        },
        imageLoaded() {
            
            this.$nextTick(() => {
                this.$refs.carousel?.$forceUpdate();
                this.$refs.carousel?.goToPage(this.navigateTo);
                if (new Date() - this.initTime > 300) {
                    setTimeout(() => {
                        this.loading = false;
                    }, 300);
                } else {
                    this.loading = false;
                }
            });
        },
        handleImgClick(image, index) {
            if (document.body.className.includes("keyboard-opened")) return;
            this.$emit("image-clicked", index, image.key);
        },
    },
    created() {
        this.initTime = new Date();
    },
    mounted() {
        this.finishRendering = true;
    },
    watch: {
        images(value, oldValue) {
            const isEqual = value.reduce((isEqual, item) => {
                return (
                    isEqual &&
                    oldValue.find((oldItem) => oldItem.key === item.key)
                );
            }, true);
            if (!isEqual) {
                this.loading = true;
                this.initTime = new Date();
            }
        },
    },
};
</script>

<style lang="scss">
.slideshow {
    width: 100%;
    .VueCarousel-wrapper {
        display: flex;
        flex: 1;
        min-height: 0;
    }
    .VueCarousel-inner {
        max-height: 100%;
        min-height: 0;
        flex-grow: 1;
    }
    .VueCarousel-slide {
        display: flex;
        align-items: center;
        .slide-image {
            max-height: 100%;
            width: 100%;
            object-fit: contain;
            display: block;
            margin: 0 auto;
        }
    }
}
</style>
